import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private gtmId = 'GTM-XXXXXXX'; // Replace with your GTM ID

  constructor(private router: Router) {
    this.addGtmToDom();
    this.trackPageViews();
  }

  private addGtmToDom(): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}`;
    document.head.appendChild(script);

    const dataLayerScript = document.createElement('script');
    dataLayerScript.innerHTML = `window.dataLayer = window.dataLayer || [];`;
    document.head.appendChild(dataLayerScript);
  }

  public pushEvent(event: any): void {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(event);
  }

  private trackPageViews(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.pushEvent({
          event: 'page_view',
          pagePath: event.urlAfterRedirects,
        });
      }
    });
  }
}
